module.exports = __webpack_public_path__ + "img/etc.a871a8c9.svg";